import { connect } from 'react-redux';
import { actions } from '../../../redux/modules/financialEntity';
import EntityCreate from './EntityCreate';
import {resetStore} from "../../../redux/modules/login";

const ms2p = (state) => {
    return {
        ...state.entity,
    };
};

const md2p = { ...actions, resetStore };

export default connect(ms2p, md2p)(EntityCreate);
